import { useEffect, type ReactElement, type ReactNode } from "react"
import { useLocation } from "react-router-dom"
import Navbar from "src/components/Navbar"
import Sidebar from "src/components/Sidebar"
import AdminMain from "./Main/AdminMain"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/app/store";
import { getDealers } from "src/features/admin/hooks/dealers";
import Spinner from "src/components/Spinner";

export interface AdminHomeProps {
        children?: ReactNode
}

export default function AdminHome(props: AdminHomeProps): ReactElement {
        const location = useLocation();
        const dispatch = useDispatch<AppDispatch>();
        const { dealersLoading } = useSelector((state: RootState) => state.dealers);

        useEffect(() => {
                dispatch(getDealers(""));
        }, [])

        return <>
                <div className="grid grid-cols-[10%_90%] h-screen w-full">
                        <div className="h-full">
                                <Sidebar sideBarSelected="Dealers" />
                        </div>
                        {dealersLoading ?
                                <Spinner title="Loading" />
                                :
                                <div className="grid grid-rows-[10%_90%] h-[inherit] w-full p-2">
                                        <div className="w-full">
                                                <div></div>
                                                <Navbar headerType="admin" />
                                                <div></div>
                                        </div>
                                        <div className="grid gap-2 grid-rows-1 w-full">
                                                <AdminMain />
                                        </div>
                                </div>
                        }
                </div>
        </>
}
